import { Link } from 'react-router-dom';
import Radium from 'radium';

const RadiumLink = Radium(Link);

export default RadiumLink;



// WEBPACK FOOTER //
// ./src/components/Link/Link.js